import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TimePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ClickOutsideModule } from 'ng-click-outside';
import { SocialAuthServiceConfig, GoogleLoginProvider, SocialLoginModule } from '@abacritt/angularx-social-login';
import { AccountModule } from './account/account.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { appRoutes } from './app.routing';
import './app.run';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AdminModule } from './portal/admin/admin.module';
import { PortalModule } from './portal/portal.module';
import { AuthGuard } from './shared/auth-guard';
import { DialogsModule } from './shared/dialogs/dialog.module';
import { EmailConfirmationPopup } from './shared/email-confirmation-popup';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import {
  AdminOptionsPrivilegeGuard,
  AnyPrivileges,
  CreateCRMXUserPrivilegeGuard,
  CRMXViewOnlyPrivilegeGuard,
  CustomerOptionsPrivilegeGuard,
  ProductSignUpPrivilegeGuard,
  ResearchPortalFullAccessPrivilegeGuard,
  ReviewProductSignUpsPrivilegeGuard,
  ApprovePWMPrivilegeGuard,
  EditPWMPrivilegeGuard,
  ViewPWMPrivilegeGuard,
  PortalDisclaimerGuard,
  redirectTo,
} from './shared/privilege-guard';
import { UtilsModule } from './utils/utils.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MobileConfirmationPopup } from './shared/mobile-confirmation-popup';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { WebcamModule } from 'ngx-webcam';
import { ResearchPortalModule } from './portal/research-portal/research-portal.module';
import { NgApexchartsModule } from 'ng-apexcharts';
// import moment from 'moment';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { ProductSignupModule } from '../app/portal/product-signup/product-signup.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { AnonymousModule } from './anonymous/anonymous.module';

export function provideConfig() {
  return {
    autoLogin: false,
    providers: [
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(environment.googleLoginProvider),
      },
    ],
  };
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    DialogsModule,
    DropDownsModule,
    InputsModule,
    SharedModule,
    UtilsModule,
    AccountModule,
    ResearchPortalModule,
    PortalModule,
    AdminModule,
    RouterModule.forRoot(appRoutes, { enableTracing: false }),
    GridModule,
    ClickOutsideModule,
    TimePickerModule,
    BsDatepickerModule.forRoot(),
    SocialLoginModule,
    LayoutModule,
    NgApexchartsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    DateInputsModule,
    ChartsModule,
    WebcamModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ProductSignupModule,
    AnonymousModule,
    MatProgressSpinnerModule,
  ],
  declarations: [AppComponent, PageNotFoundComponent, MaintenanceComponent],
  providers: [
    AuthGuard,
    EmailConfirmationPopup,
    MobileConfirmationPopup,
    AdminOptionsPrivilegeGuard,
    ApprovePWMPrivilegeGuard,
    EditPWMPrivilegeGuard,
    PortalDisclaimerGuard,
    ViewPWMPrivilegeGuard,
    AnyPrivileges,
    CustomerOptionsPrivilegeGuard,
    ProductSignUpPrivilegeGuard,
    ReviewProductSignUpsPrivilegeGuard,
    CRMXViewOnlyPrivilegeGuard,
    CreateCRMXUserPrivilegeGuard,
    ResearchPortalFullAccessPrivilegeGuard,
    redirectTo,
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: provideConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
